import initI18n from '@wix/da-i18next/pkg/presetI18nClientConfigNg';
// project-base needs to go before app styles
// eslint-disable-next-line
import '@wix/da-ds/src/styles/project-base.scss';
import App from './components/App';
import { configureStore } from './store/configure-store';
import { hydrateRoot } from 'react-dom/client';
import { PATH_MAPPINGS } from '../path-mappings';
import { getClientInstance } from '@wix/da-ddt';
import { getEnv } from '@wix/da-react-app/pkg/client/Environment/redux/selectors';
import AppDocumentWrapper from '@wix/da-react-app/pkg/client/AppDocumentWrapper/AppDocumentWrapper';
import { I18nextProvider } from 'react-i18next';
import i18n from 'i18next';
import Modal from 'react-modal';

const ddt = getClientInstance();
ddt.replayServerSideLogs(window['__DDT__']);

const initialState = window['__INITIAL_STATE__'];
delete window['__INITIAL_STATE__'];
const store = configureStore(initialState);
const state = store.getState();

// Get the page from the URL path on the client side
const getPageFromPath = (pathname: string): string => {
  // Handle dynamic routes like reset-password
  if (pathname.startsWith('/users/reset-password/')) {
    return 'reset-password';
  }

  return PATH_MAPPINGS[pathname] || 'join';
};

const currentPage = getPageFromPath(window.location.pathname);

const initialI18n = window['__INITIAL_I18N__'];
initI18n(
  {
    ...initialI18n,
    options: {
      fallbackNS: 'translation',
    },
  },
  getEnv(state).isDebug,
  getEnv(state).flags
);

Modal.setAppElement('body');
hydrateRoot(
  document,
  <I18nextProvider i18n={i18n}>
    <AppDocumentWrapper store={store}>
      <App language={initialI18n.locale} page={currentPage} />
    </AppDocumentWrapper>
  </I18nextProvider>
);
